import { z } from 'zod'

/** 取得營業人員資訊 Request Schema */
export const salesInformationRequestSchema = z.object({
  /** 員工編號 */
  empNo: z.array(z.string())
})

/** 取得營業人員資訊 Request */
export interface SalesInformationRequest
  extends z.infer<typeof salesInformationRequestSchema> {}

export class SalesInformationRequest {
  constructor() {
    return {
      empNo: []
    }
  }
}
